import { queryOptions, useQuery } from '@tanstack/react-query'
import reconciliationQueryKeys from './reconciliationQueryKeys'
import { getReconciliationMatches } from '../service/reconciliationService'
import { useCtxGroupCompany } from '../../companyGroup/queries/useCtxGroupCompany'

export const useCtxReconciliationMatches = () => {
  const { data: groupCompany } = useCtxGroupCompany()
  const groupCompanyId = groupCompany?.id

  return useQuery(
    queryOptions({
      queryKey: reconciliationQueryKeys.list({ groupCompanyId }),
      queryFn: getReconciliationMatches,
      enabled: !!groupCompanyId,
      gcTime: 15 * 60 * 1000
    })
  )
}
